// Vehicle Statuses - Single Source of Truth
export const VEHICLE_STATUS = {
    PENDING_APPROVAL: 'pending_approval',
    APPROVED: 'approved',
    FACILITY_ENTERED: 'facility_entered',
    IN_PARKING: 'in_parking',
    LOADING_STARTED: 'loading_started',
    LOADING_COMPLETED: 'loading_completed',
    FACILITY_EXITED: 'facility_exited',
    CANCELLED: 'cancelled',
    TRANSPORTER_REVISED: 'transporter_revised'
};

// Status Display Names (Turkish)
export const STATUS_LABELS = {
    [VEHICLE_STATUS.PENDING_APPROVAL]: 'Onay Bekliyor',
    [VEHICLE_STATUS.APPROVED]: 'Onaylandı',
    [VEHICLE_STATUS.FACILITY_ENTERED]: 'Tesise Girdi',
    [VEHICLE_STATUS.IN_PARKING]: 'Park Alanında',
    [VEHICLE_STATUS.LOADING_STARTED]: 'Yükleme Başladı',
    [VEHICLE_STATUS.LOADING_COMPLETED]: 'Yükleme Bitti',
    [VEHICLE_STATUS.FACILITY_EXITED]: 'Tesisten Çıktı',
    [VEHICLE_STATUS.CANCELLED]: 'İptal',
    [VEHICLE_STATUS.TRANSPORTER_REVISED]: 'Nakliyeci Revize Etti',

    // Backward Compatibility Mappings (To be refactored out)
    'rejected': 'İptal',
    'confirmed': 'Onaylandı',
    'transporter_confirmed': 'Onaylandı',
    'pending': 'Onay Bekliyor',
    'entered': 'Tesise Girdi',
    'parking': 'Park Alanında',
    'loading': 'Yükleme Başladı',
    'completed': 'Yükleme Bitti',
    'exited': 'Tesisten Çıktı',
    'loading_start': 'Yükleme Başladı',
    'loading_end': 'Yükleme Bitti',
    'waiting_reservation': 'Onay Bekliyor'
};

// Status Colors
export const STATUS_COLORS = {
    [VEHICLE_STATUS.PENDING_APPROVAL]: '#F59E0B', // Amber
    [VEHICLE_STATUS.APPROVED]: '#3B82F6',       // Blue
    [VEHICLE_STATUS.FACILITY_ENTERED]: '#10B981', // Emerald
    [VEHICLE_STATUS.IN_PARKING]: '#8B5CF6',     // Violet
    [VEHICLE_STATUS.LOADING_STARTED]: '#F97316',  // Orange
    [VEHICLE_STATUS.LOADING_COMPLETED]: '#059669', // Green
    [VEHICLE_STATUS.FACILITY_EXITED]: '#64748B',  // Slate
    [VEHICLE_STATUS.CANCELLED]: '#EF4444',      // Red
    [VEHICLE_STATUS.TRANSPORTER_REVISED]: '#D946EF',   // Fuchsia/Magenta
    'rejected': '#EF4444',
    'confirmed': '#3B82F6',
    'transporter_confirmed': '#3B82F6',
    'pending': '#F59E0B',
    'entered': '#10B981',
    'parking': '#8B5CF6',
    'loading': '#F97316',
    'completed': '#059669',
    'exited': '#64748B',
    'loading_start': '#F97316',
    'loading_end': '#059669'
};

// Approval Statuses
export const APPROVAL_STATUS = {
    PENDING: 'pending',
    COORDINATOR_APPROVED: 'coordinator_approved',
    TRANSPORTER_APPROVED: 'transporter_approved',
    BOTH_APPROVED: 'both_approved'
};

// Reservation Slot Statuses
export const SLOT_STATUS = {
    AVAILABLE: 'available',
    RESERVED: 'reserved',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed'
};
